module.exports = __webpack_public_path__ + "static/media/Mobile_Data_API_GATEWAY.0be52301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/APIGATEWAY/Mobile_Data_API_GATEWAY.png
// module id = 71
// module chunks = 0